import { strCode } from "../localizations/strCode";
import destinations from "./destinations";

const destinationOptions = [
  { id: destinations.pauseMode, value: strCode.PAUSE_MODE_DESTINATION_OPTION },
  { id: destinations.flexPuff, value: strCode.FLEX_PUFF_DESTINATION_OPTION },
  { id: destinations.flexBattery, value: strCode.FLEX_BATTERY_DESTINATION_OPTION },
  { id: destinations.softwareUpdate, value: strCode.SOFTWATRE_UPDATE_DESTINATION_OPTION },
  { id: destinations.lowPerformance, value: strCode.LOW_PERFORMANCE_DESTINATION_OPTION },
  {
    id: destinations.personalizedCharging,
    value: strCode.PERSONALIZED_CHARGING_DESTINATION_OPTION
  },
  { id: destinations.loyalty, value: strCode.LOYALTY_DESTINATION_OPTION },
  { id: destinations.usage, value: strCode.USAGE_DESTINATION_OPTION },
  { id: destinations.home, value: strCode.HOME_DESTINATION_OPTION },
  { id: destinations.experienceCoach, value: strCode.EXPERIENCE_COACH_DESTINATION_OPTION },
  { id: destinations.loyaltyBadges, value: strCode.LOYALTY_BADGES_DESTINATION_OPTION },
  { id: destinations.notifications, value: strCode.NOTIFICATIONS_DESTINATION_OPTION }
];

export default destinationOptions;
